import { RootState } from '../root.reducers';
import { Xdp } from './xdp.types';

export const getXdps = (state: RootState): Xdp[] => state.xdp.entities;

export const getSelectedXdp = (state: RootState): Xdp[] => state.xdp.select;

export const getXdp = (state: RootState): Xdp | null =>
  state.xdp.single;
